import useSWR from 'swr'
import { learningApi } from 'services/api'
import { TExcertoAnnotations } from './types'

interface IParams {
  courseId: string
  moduleId: string
  lessonId: string
  chapterId: string
}

export function useGetExcertoAnnotations(params: IParams) {
  const { courseId, moduleId, lessonId, chapterId } = params

  const token = localStorage.getItem('token')

  const url = '/annotation/get-annotation'

  const body = {
    courseId,
    moduleId,
    lessonId,
    chapterId,
    objectType: 'excerpt',
  }

  const key = token ? [url, body, token] : null

  const swr = useSWR<TExcertoAnnotations>(key, fetcher, {
    fallbackData: { marks: [], notes: [] },
    dedupingInterval: 5000,
  })

  return swr
}

const fetcher = ([url, body, token]: [string, Record<string, any>, string]) =>
  learningApi
    .post(url, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => res.data)
    .then((data) => {
      const marks = []
      const notes = []

      data.forEach((annotation) => {
        const isMark = !!annotation.highlight

        if (isMark) {
          marks.push(annotation)
        } else {
          notes.push(annotation)
        }
      })

      return { marks, notes }
    })

export type TSwrExcertoAnnotations = ReturnType<typeof useGetExcertoAnnotations>
